import { IUpdateProps } from '@src/slide/application/service/paragraph-manager/core/paragraph-manager';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

function getBaseTdwObject() {
    return {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.PARAGRAPH_PANEL,
    };
}

export function handleParagraphMoreDialogTdw(updateProps: IUpdateProps): void {
    if (updateProps.alignmentType) {
        tdw({
            ...getBaseTdwObject(),
            action: TDWActionType.SET_ALIGNMENT,
            ver5: updateProps.alignmentType,
        });
    }
    if (updateProps.textIndent) {
        tdw({
            ...getBaseTdwObject(),
            action: TDWActionType.SET_INDENTATION,
            ver5: updateProps.textIndent,
        });
    }
    if (updateProps.lineHeight && updateProps.lineHeightType) {
        tdw({
            ...getBaseTdwObject(),
            action: TDWActionType.SET_SPACING,
            ver5: 3,
            ver6: updateProps.lineHeight,
            ver7: updateProps.lineHeightType,
        });
    }
    if (updateProps.spaceBefore) {
        tdw({
            ...getBaseTdwObject(),
            action: TDWActionType.SET_SPACING,
            ver5: 1,
            ver6: updateProps.spaceBefore,
        });
    }
    if (updateProps.spaceAfter) {
        tdw({
            ...getBaseTdwObject(),
            action: TDWActionType.SET_SPACING,
            ver5: 2,
            ver6: updateProps.spaceAfter,
        });
    }
    if (updateProps.tabList || updateProps.tabSize) {
        tdw({
            ...getBaseTdwObject(),
            action: TDWActionType.ADD_TAB,
            ver5: JSON.stringify(updateProps.tabList),
            ver6: updateProps.tabSize,
        });
    }
}

export function onClickTabstopModalTdw(): void {
    tdw({
        ...getBaseTdwObject(),
        action: TDWActionType.TABS_CLK,
    });
}
